import {useEffect, useState} from "react";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useGetUserPreferencesQuery} from "../../user/api/get_user_preferences";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../../user/constants/preferences/application_preferences_form";
import {useSubscribeToNewsletter} from "./useSubscribeToNewsletter";

interface initialValuesType {
    budget: number;
    rooms: {lower?: number; upper?: number};
    marketing_email: boolean;
    marketing_sms: boolean;
    regionSelector: {value: number; label: string}[];
    regions: {value: number; label: string}[];
}

export const useNewsletterDefaultValues = (initialValues: initialValuesType) => {
    const {data: userProfile, isLoading: isUserProfileLoading} = useGetUserProfileQuery();
    const {data: userPreferences, isLoading: isPreferencesLoading} = useGetUserPreferencesQuery();
    const regionIds = userPreferences?.filters?.region?.map((region) => parseInt(region, 10)) ?? [];
    const {data: regionDetails, isLoading: isRegionDetailsLoading} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const {getNewsletterSearchData} = useSubscribeToNewsletter();
    const newsletterSearchData = getNewsletterSearchData();
    const [defaultValues, setDefaultValues] = useState<initialValuesType>(initialValues);

    useEffect(() => {
        const newsletterRegionOptions =
            newsletterSearchData?.search && "regions" in newsletterSearchData.search
                ? newsletterSearchData.search.regions.map((region: {id: number; short_name: string}) => ({value: region.id, label: region.short_name}))
                : [];
        const regionOptions = regionDetails?.length ? regionDetails.map((region) => ({value: region.id, label: region.name})) : newsletterRegionOptions;

        const preferencesPrice1 = userPreferences?.filters?.price_1;
        const budget = preferencesPrice1
            ? Math.min(parseInt(preferencesPrice1, 10), PREFERENCES_FORM_MAX_DEFAULT)
            : newsletterSearchData?.price?.upper
              ? Math.min(newsletterSearchData.price.upper, PREFERENCES_FORM_MAX_DEFAULT)
              : PREFERENCES_FORM_MAX_DEFAULT;

        const preferencesRooms0 = userPreferences?.filters?.rooms_0;
        const preferencesRooms1 = userPreferences?.filters?.rooms_1;
        const rooms =
            preferencesRooms0 || preferencesRooms1
                ? {
                      lower: preferencesRooms0 ? parseInt(preferencesRooms0, 10) : undefined,
                      upper: preferencesRooms1 ? parseInt(preferencesRooms1, 10) : undefined
                  }
                : (newsletterSearchData?.rooms ?? {lower: undefined, upper: undefined});

        const values = {
            budget,
            rooms,
            marketing_email: userProfile?.email_marketing_consent ?? false,
            marketing_sms: userProfile?.phone_marketing_consent ?? false,
            regionSelector: regionOptions,
            regions: regionOptions
        };

        setDefaultValues(values);
    }, [regionDetails, userProfile, userPreferences]);

    return {
        loadingDefaultValues: isPreferencesLoading || isRegionDetailsLoading || isUserProfileLoading,
        defaultValues
    };
};
import {useEffect, useState} from "react";

import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useGetUserPreferencesQuery} from "../../user/api/get_user_preferences";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {PREFERENCES_FORM_MAX_DEFAULT} from "../../user/constants/preferences/application_preferences_form";
import {useSubscribeToNewsletter} from "./useSubscribeToNewsletter";

interface initialValuesType {
    budget: number;
    rooms: {lower?: number; upper?: number};
    marketing_email: boolean;
    marketing_sms: boolean;
    regionSelector: {value: number; label: string}[];
    regions: {value: number; label: string}[];
}

export const useNewsletterDefaultValues = (initialValues: initialValuesType) => {
    const {data: userProfile, isLoading: isUserProfileLoading} = useGetUserProfileQuery();
    const {data: userPreferences, isLoading: isPreferencesLoading} = useGetUserPreferencesQuery();
    const regionIds = userPreferences?.filters?.region?.map((region) => parseInt(region, 10)) ?? [];
    const {data: regionDetails, isLoading: isRegionDetailsLoading} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const {getNewsletterSearchData} = useSubscribeToNewsletter();
    const newsletterSearchData = getNewsletterSearchData();
    const [defaultValues, setDefaultValues] = useState<initialValuesType>(initialValues);

    useEffect(() => {
        const newsletterRegionOptions =
            newsletterSearchData?.search && "regions" in newsletterSearchData.search
                ? newsletterSearchData.search.regions.map((region: {id: number; short_name: string}) => ({value: region.id, label: region.short_name}))
                : [];
        const regionOptions = regionDetails?.length ? regionDetails.map((region) => ({value: region.id, label: region.name})) : newsletterRegionOptions;

        const preferencesPrice1 = userPreferences?.filters?.price_1;
        const budget = preferencesPrice1
            ? Math.min(parseInt(preferencesPrice1, 10), PREFERENCES_FORM_MAX_DEFAULT)
            : newsletterSearchData?.price?.upper
              ? Math.min(newsletterSearchData.price.upper, PREFERENCES_FORM_MAX_DEFAULT)
              : PREFERENCES_FORM_MAX_DEFAULT;

        const preferencesRooms0 = userPreferences?.filters?.rooms_0;
        const preferencesRooms1 = userPreferences?.filters?.rooms_1;
        const rooms =
            preferencesRooms0 || preferencesRooms1
                ? {
                      lower: preferencesRooms0 ? parseInt(preferencesRooms0, 10) : undefined,
                      upper: preferencesRooms1 ? parseInt(preferencesRooms1, 10) : undefined
                  }
                : (newsletterSearchData?.rooms ?? {lower: undefined, upper: undefined});

        const values = {
            budget,
            rooms,
            marketing_email: userProfile?.email_marketing_consent ?? false,
            marketing_sms: userProfile?.phone_marketing_consent ?? false,
            regionSelector: regionOptions,
            regions: regionOptions
        };

        setDefaultValues(values);
    }, [regionDetails, userProfile, userPreferences]);

    return {
        loadingDefaultValues: isPreferencesLoading || isRegionDetailsLoading || isUserProfileLoading,
        defaultValues
    };
};
